import { AdvisorLayerMode, useResolvedAdvisorLayerMode } from '@components'

import { useMemo } from 'react'

import { useUserOrganizationMembership } from '@modules-deprecated/app/organization/hooks/useUserOrganizationMembership'

import { useIsCpaOrganization } from '../../../hooks/useIsCpaOrganization'
import { DmsUserRole } from '../enums/dmsUserRole'

interface UseDmsUserRoleResult {
  role: DmsUserRole | undefined
  isLoading: boolean
  isBo: boolean
  isBoWithoutCpa: boolean
  isBoWithCpa: boolean
  isCpa: boolean
  isCpaClientMode: boolean
  isCpaExpertMode: boolean
}

export const useDmsUserRole = (): UseDmsUserRoleResult => {
  const { isCpaOrganization, isLoading } = useIsCpaOrganization()
  const { isViaUmbrella } = useUserOrganizationMembership()
  const advisorLayerMode = useResolvedAdvisorLayerMode()
  const isAdvisorExpertLayer = advisorLayerMode === AdvisorLayerMode.Expert

  const role = useMemo((): DmsUserRole | undefined => {
    if (isLoading || isCpaOrganization === undefined) {
      return undefined
    }
    if (!isCpaOrganization) {
      return DmsUserRole.BoWithoutCpa
    }
    if (!isViaUmbrella) {
      return DmsUserRole.BoWithCpa
    }
    if (!isAdvisorExpertLayer) {
      return DmsUserRole.CpaClientMode
    }
    return DmsUserRole.CpaExpertMode
  }, [isLoading, isCpaOrganization, isViaUmbrella, isAdvisorExpertLayer])

  return useMemo(
    () => ({
      role,
      isLoading: role === undefined,
      isBoWithoutCpa: role === DmsUserRole.BoWithoutCpa,
      isBoWithCpa: role === DmsUserRole.BoWithCpa,
      isCpaClientMode: role === DmsUserRole.CpaClientMode,
      isCpaExpertMode: role === DmsUserRole.CpaExpertMode,
      isBo: role === DmsUserRole.BoWithoutCpa || role === DmsUserRole.BoWithCpa,
      isCpa: role === DmsUserRole.CpaClientMode || role === DmsUserRole.CpaExpertMode,
    }),
    [role],
  )
}
